import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

import type { ChatFlowGetAllLanguagesPayloadT } from '../api/types';

export const flowLanguagesActions = createActions(
  {
    FLOW_GET_LANGUAGES: [
      (payload: ChatFlowGetAllLanguagesPayloadT) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
  },
  'FLOW_GET_LANGUAGES_SUCCEEDED',
  'FLOW_GET_LANGUAGES_FAILED',
);
